export default __webpack_public_path__ + "static/media/LeekHotPot_01.ed7ff007.png";